export default __webpack_public_path__ + "static/media/oscer-tour-welcome.5f867414.svg";